import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { makeStyles, Typography, TypographyProps } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  list: { paddingLeft: theme.spacing(2), listStyle: 'disc' },
}));

export const TextList: { Item: typeof Item } & React.FC<React.HTMLProps<HTMLUListElement>> = (
  props,
) => {
  const classes = useStyles();

  return <ul className={classes.list} {...props} />;
};

const Item: React.FC<TypographyProps<'li'>> = (props) => <Typography {...props} component='li' />;

TextList.Item = Item;
